import Hero from "../Components/Hero";

const Home = () => <Hero />;

export default Home;
